import * as React from "react";

import FlowForm from "../../components/Forms/ParkingLot/FlowForm/FlowForm";

export default () => {
  return <FlowForm method="POST" />;
};
